import { defineComponent as _defineComponent } from 'vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'EmailConfirmation',
  props: {
    sentEmailConfirmation: {
        type: Boolean,
        default: false
    }
},
  emits: [
    'clickBackToLogin', 'sendNewLink'
],
  setup(__props, { emit }) {

const props = __props





const clickBackToLogin = () => {
    emit('clickBackToLogin')
}

const clickSendNewLink = () => {
    emit('sendNewLink')
}

return { __sfc: true,props, emit, clickBackToLogin, clickSendNewLink }
}

})